// The system's share sheet, for Share on a card and Invite (features/map.md, "The share sheet wherever there
// is one"; DESIGN.md log rows "A share sheet on a computer" and "A sheet only where it always opens"): whether
// this browser's is one Tripmo opens. Plain data in, so it's tested without a browser
// (test/share-sheet.test.ts); `hasShareSheet` in Invite.tsx reads the browser.

// The browser as the page reads it: its user agent, its touch points, and `navigator.userAgentData`'s brands
// where there is one (Chromium's; Safari and Firefox have none).
export type Browser = {
  userAgent: string;
  maxTouchPoints: number;
  brands: readonly string[] | null;
};

// Whether the browser's share sheet opens, pointing at what was pressed, every time: Tripmo opens a sheet only
// where it does, and only there puts Copy link beside Share, so Share never opens the sheet for one press and
// copies for the next. Not in Chrome, Edge or any browser built on Chromium on a Mac: it points the sheet's
// tip at the mouse cursor read as if the page filled the window, so side tabs, a side panel on the left or
// DevTools docked left or at the bottom put the tip off the page, and a page can't be sure they won't (#846
// measured each). There Share copies the link, as where there's no sheet. Safari on a Mac places it right,
// for a key too (the tip then at the cursor); Windows' and ChromeOS's sheets have no tip; a phone's and an
// iPad's open from the button.
export function sheetAlwaysOpens(browser: Browser): boolean {
  // A Mac: an iPad says Macintosh too, with 5 touch points.
  const mac = browser.userAgent.includes("Macintosh") && browser.maxTouchPoints <= 1;
  if (!mac) return true;
  // A Chromium browser that hides `userAgentData` still says "Chrome/" in its user agent; Safari never does.
  const chromium = browser.brands ? browser.brands.includes("Chromium") : browser.userAgent.includes("Chrome/");
  return !chromium;
}
